import { result } from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { AddConveniosComponent } from '../convenios-list/add-convenios/add-convenios.component';
import { ConveniosAddEditComponent } from './convenios-add-edit/convenios-add-edit.component';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ConveniosTreeViewService } from '../services/convenios-tree-view.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-convenios-detail',
    templateUrl: './convenios-detail.component.html',
    styleUrls: ['./convenios-detail.component.scss'],
    standalone: false
})

export class ConveniosDetailComponent implements OnInit {
  @Input() convenioId: any;
  @Input() selectedNode: [];
  selectedGroupo: string;
  selectedNombre: string;
  clickEventSubscription: Subscription;
  isTopButtonShow: boolean = true;
  isEliminarActive: boolean = true;
  displayedColumns = ['position', 'name', 'weight', 'symbol', 'symbol2', 'delete'];
  dataSource;
  isError :boolean =false;
  isFirstLoad:boolean =false;
  masterElement : any;

  constructor(
    private _conveniosTreeViewService: ConveniosTreeViewService,
    private _sharedService: SharedService,
    private _dialog: MatDialog,
  ) {
    this.clickEventSubscription = this._conveniosTreeViewService.getClickUpdateTopButtonsEvent().subscribe(() => {
      this._conveniosTreeViewService.topButtonsEditValue.subscribe(companyId => this.isTopButtonShow = companyId);
    });
  }

  ngOnInit(): void {
    this.loadCriterioConvenio();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.selectedNode) {
      for (var index in this.selectedNode) {
        this.selectedGroupo = this.selectedNode['name'];
        this.selectedNombre = this.selectedNode['nombre'];
        this.convenioId = this.selectedNode['convenioId'];
      }
    }
    this.loadCriterioConvenio();
  }

  checkMinAndMax(min :any, max:any,value){
    if(value==null)return false;

    if(min>value)
    {
      this.isError=true;
      return true 
    }
    if(max<value)
    {
      this.isError=true;
      return true 
    }
    return false
  }

  loadCriterioConvenio() {
    if (this.selectedNode && this.convenioId) {
      this._conveniosTreeViewService.getCriterioConvenio(this.convenioId).subscribe(res => {
        if (res) {
          if(res.result.length>0)
          {
            this.isEliminarActive=true;
          }
          else
          {
            this.isEliminarActive=false;
          }
          this.dataSource = res.result;
          this.isFirstLoad=true;
          this.dataSource.forEach(element => {
            element['isEdit'] = false;
          });
        }
      });
    }
    else {
      this.dataSource = null;
    }
    
  }

  onEdit(element) {
    this.masterElement=element;
    this.isFirstLoad=false;
    element.isEdit = true;
  }

  checkValidity(element: any){
    if(element.diasDesde==null &&  element.diasHasta==null && element.complemento==null && element.bajasDesdeDias==null && element.bajasHastaDia ==null)return false 
    if(element.diasDesde>545  || element.diasDesde ==0 ||  element.diasHasta>545 || element.diasHasta==0 || element.bajasDesdeDias>545 || element.bajasDesdeDias==0 || element.bajasHastaDias>545 || element.bajasHastaDias==0 || element.complemento>100 || element.complemento<0)
    {
      this.isError=true;
    }else
    {
      this.isError=false;
    }
    
    return true; 
  }

  onSave(element) {
    if(this.checkValidity(element)){
      
      if(!this.isError)
      {
        element.isEdit = false;
        this._conveniosTreeViewService.updateCriterioConvenio(element).subscribe();
      }
      
    }else{
      this._sharedService.ShowSnackBar('Se debe rellenar almenos un campo', 'Okay', 2000);
    }
  }

  onClose(element) {
    this.loadCriterioConvenio();
  }

  deleteConvenios() {
    this._conveniosTreeViewService.checkConvenioUsed(this.convenioId).subscribe(res => {
      if (res) {
        if (res.result == 0) {
          const dialogData = new ConfirmDialogModel('¿Eliminar convenio?', '');
          const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            data: dialogData
          });
          dialogRef.afterClosed().subscribe(response => {
            if (response) {
              this._conveniosTreeViewService.deleteConvenioUsed(this.convenioId).subscribe(res => {
                if (res) {
                  this._sharedService.ShowSnackBar('Convenio eliminado', 'Okay', 2000);
                  this.refershPage();
                }
              });
            }
          }
          );
        }
        else if (res.result == 1) {
          this._sharedService.ShowSnackBar('Es convenio se está usando en al menos una empresa', 'Okay', 2000);
        }
        else if (res.result == 2) {
          this._sharedService.ShowSnackBar('Es convenio se está usando en al menos en un atributo de una empresa', 'Okay', 2000);
        }
      }
    });
  }
  public openAgendaAddEdit(data: any): void {
    const dialogRef = this._dialog.open(ConveniosAddEditComponent, {
      data: { convenioId: this.convenioId }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.loadCriterioConvenio();
    });
  }

  public editConvenios() {
    const dialogRefEdit = this._dialog.open(AddConveniosComponent, {
      data: { convenioId: this.convenioId, nombre: this.selectedNombre, groupo: this.selectedGroupo, isInsert: false }
    });
    dialogRefEdit.afterClosed().subscribe(res => {
      if (res) {
        this._sharedService.ShowSnackBar('Editado con éxito', 'Okay', 2000);
        this.selectedNombre = res.Nombre;
        this.selectedGroupo = res.Grupo;
        this.refershPage();
      }

    });
  }

  public refershPage() {
    this._conveniosTreeViewService.changeEditStatus(true);
    this._conveniosTreeViewService.sendClickUpdateEvent();
    this.loadCriterioConvenio();
  }
}

export interface PeriodicElement {
  name: number;
  position: number;
  weight: number;
  symbol: number;
  symbol2: number;
  delete: number;
}
